import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { globalTheme } from '@playbookux/playbook-web-core';
import Avatar from '../../../core/components/avatar';
import Demographics from '../../../core/components/demographics';
import Employment from '../../../core/components/employment';

import {
  Card,
  CardClickRow,
  CardHeader,
  CardRow,
  Column,
  ColumnText,
  Grid,
  Icon,
  Image,
  Item,
  LinkedInInfo,
  Menu,
  MenuContainer,
  Link,
} from './styles';

const MenuFlaps = (props) => (
  <MenuContainer>
    <Menu pointing secondary stackable>
      <Item
        name="demographics"
        active={props.activeItem === 'demographics'}
        onClick={props.onClickMenuItem}
      />
      <Item
        name="employment"
        active={props.activeItem === 'employment'}
        onClick={props.onClickMenuItem}
      />
    </Menu>
  </MenuContainer>
);

MenuFlaps.propTypes = {
  activeItem: PropTypes.string.isRequired,
  onClickMenuItem: PropTypes.func.isRequired,
};

const Tester = (props) => {
  const { index, link, user } = props;
  const { profile } = user;
  const picture = _.get(user, ['profile', 'linkedinFields', 'pictureUrl'], '');

  const [activeItem, setActiveItem] = useState('demographics');
  const [showCard, setShowCard] = useState(false);
  const [pictureUrl, setPictureUrl] = useState(picture);

  const onClickMenuItem = (e, { name }) => {
    setActiveItem(name);
  };

  const onClickShowCard = () => {
    setShowCard(!showCard);
  };

  const onPictureUrlError = () => {
    setPictureUrl(null);
  };

  const linkedinUrl = _.get(user, ['profile', 'linkedinFields', 'linkedinUrl'], '');
  const name = user.profile ? `${user.profile.firstName} ${user.profile.lastName}` : user.email;
  const avatarColors = globalTheme.color.avatarBackground;
  const avatarColor = avatarColors[index % avatarColors.length];

  return (
    <CardRow>
      <Card>
        <CardHeader>
          <Grid>
            <CardClickRow onClick={onClickShowCard}>
              <Column width={1}>
                {!pictureUrl && (
                  <Avatar
                    color={avatarColor}
                    firstName={name}
                  />
                )}

                {pictureUrl && (
                  <Image
                    avatar
                    src={pictureUrl}
                    onError={onPictureUrlError}
                  />
                )}
              </Column>
              <Column width={3}>
                <ColumnText>
                  {name}
                </ColumnText>
              </Column>
              <Column width={1}>
                {user.guest && (
                  <ColumnText
                    color="red"
                    weight="bold"
                  >
                    G
                  </ColumnText>
                )}
              </Column>
              <Column width={1}>
                <Link href={`/tester/${user.id}`} target="_blank">
                  Link
                </Link>
              </Column>
              <Column width={3} />
              <Column width={3} />
              <Column width={2}>
                {_.isEmpty(linkedinUrl) && (
                  <LinkedInInfo>No LinkedIn info</LinkedInInfo>)}
              </Column>

              <Column width={1}>
                <Icon
                  size="small"
                  name={showCard ? 'chevron up' : 'chevron down'}
                />
              </Column>

            </CardClickRow>
          </Grid>
        </CardHeader>

        {showCard && (
          <>
            <MenuFlaps
              activeItem={activeItem}
              onClickMenuItem={onClickMenuItem}
            />
            {(activeItem === 'demographics') && (
              <Demographics profile={profile} link={`/testers/${user.id}/personal`} showTitle />
            )}
            {(activeItem === 'employment') && (
              <Employment profile={profile} link={link} showTitle />
            )}
          </>
        )}
      </Card>
    </CardRow>
  );
};

Tester.propTypes = {
  index: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
};

export default Tester;
